import React, { useState } from 'react';
import { Content } from './components/Content/Content';
import { Footer } from './components/Footer/Footer';
import { Header } from './components/Header/Header';
import { AppContext } from './context/AppContext';

function App() {
  const [mobileMode, setMobileMode] = useState(() => window.innerWidth <= 600);

  window.addEventListener('resize', e => {
    setMobileMode(() => (e.target.innerWidth <= 600 ? true : false));
  });

  return (
    <AppContext.Provider value={{ mobileMode }}>
      <div className="App">
        <Header mobileMode={mobileMode} />
        <Content mobileMode={mobileMode} />
        <Footer />
      </div>
    </AppContext.Provider>
  );
}

export default App;
